const config = {
  invoiceServiceURL: process.env.REACT_APP_INVOICE_SERVICE_URL,
  paymentServiceURL: process.env.REACT_APP_PAYMENT_SERVICE_URL,
  customerServiceURL: process.env.REACT_APP_CUSTOMER_SERVICE_URL,
  expenseServiceURL: process.env.REACT_APP_EXPENSE_SERVICE_URL,
  inventoryServiceURL: process.env.REACT_APP_INVENTORY_SERVICE_URL,
  notificationServiceURL: process.env.REACT_APP_NOTIFICATION_SERVICE_URL,
  vendorServiceURL: process.env.REACT_APP_VENDOR_SERVICE_URL,
  profileServiceURL: process.env.REACT_APP_PROFILE_SERVICE_URL,
  subscriptionServiceURL: process.env.REACT_APP_SUBSCRIPTION_SERVICE_URL,
  CognitoUserPoolId: process.env.REACT_APP_COGNITO_USERPOOL_ID,
  CognitoClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  PayStackPublicKey: "pk_test_50a3b15838c904b80ceb590f72ae034ccfdf7155"
};

export default config;
